
<!--
  File name: AppBar.vue
  Program Description:
    - This component renders the App Bar and the menu button of the whole
    system.
-->

<template>
  <v-app-bar
    app
    :color="`transparent`"
    flat
    absolute
    extended
    class="app-bar"
  >
    <slot name="menu" />
  </v-app-bar>
</template>

<script>

export default {
  name: 'AppBar',
  props: {
    showDrawer: Boolean
  },
  data () {
    return {
    }
  },
  created () {
  },
  beforeUpdate () {
  },
  methods: {
  }
}
</script>

<style scoped>
  .app-bar{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

</style>
